import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { updateAuthToSSO } from "slices/systemAdmin/actions/authentication";

const EnableSsoModal = ({ id, url, cert }) => {
  const dispatch = useDispatch();

  const handleConfirmation = () => {
    dispatch(updateAuthToSSO(id, url, cert));
  };
  const handleCancel = () => {
    dispatch(hideModal(modalTypes.ENABLE_SSO));
  };

  const modalBody = () => (
    <div className="enable__sso__modal__body">
      <p>
        This will immediately change the authentication method of your
        deployment. Changing this setting will terminate your session and any
        other active sessions. Would you like to continue?
      </p>
    </div>
  );

  return (
    <Modal
      data-test="deleteWorkspaceModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop
      centered
    >
      <Modal.Header>
        <b>Are you sure?</b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <NewButton
          data-test="cancelButton"
          variant={NewButtonVariant.l2}
          onClick={handleCancel}
        >
          Cancel
        </NewButton>

        <NewButton
          data-test="saveButton"
          variant={NewButtonVariant.l1}
          onClick={() => {
            handleConfirmation();
          }}
          disabled={false}
        >
          Confirm
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default EnableSsoModal;

EnableSsoModal.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  cert: PropTypes.string.isRequired,
};
